import { render, staticRenderFns } from "./CheckConfigSLOLatencyForm.vue?vue&type=template&id=27c49b9a&scoped=true"
import script from "./CheckConfigSLOLatencyForm.vue?vue&type=script&lang=js"
export * from "./CheckConfigSLOLatencyForm.vue?vue&type=script&lang=js"
import style0 from "./CheckConfigSLOLatencyForm.vue?vue&type=style&index=0&id=27c49b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c49b9a",
  null
  
)

export default component.exports